import { useLocation } from "react-router-dom";
import { CONTENT } from "@/content";

export default function Placeholder() {
  const { pathname } = useLocation();
  return (
    <main className="page placeholder" data-testid="placeholder-page">
      <h1 className="placeholder-title" data-testid="placeholder-title">{CONTENT.placeholders[pathname]}</h1>
    </main>
  );
}
